var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "section bg-primary is-radiusless" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "columns is-mobile" }, [
        _c(
          "div",
          {
            staticClass:
              "column is-4-desktop is-offset-4-desktop is-6-tablet is-offset-3-tablet is-10-mobile is-offset-1-mobile"
          },
          [
            _c(
              "div",
              {},
              [
                _vm._m(0),
                _vm._v(" "),
                _vm.$store.state.formError
                  ? _c("div", { staticClass: "notification is-danger mb-6" }, [
                      _c("div", { staticClass: "media" }, [
                        _c(
                          "div",
                          { staticClass: "media-left" },
                          [_c("b-icon", { attrs: { icon: "alert" } })],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "media-content" }, [
                          _c("p", {
                            domProps: {
                              textContent: _vm._s(_vm.$store.state.formError)
                            }
                          })
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { attrs: { id: "firebaseui-auth-container" } }),
                _vm._v(" "),
                _vm._l(_vm.links, function(link, index) {
                  return _c(
                    "router-link",
                    {
                      key: index,
                      staticClass: "button is-fullwidth mt-2",
                      class: link.classes,
                      attrs: { to: link.to }
                    },
                    [
                      _c("span", {
                        domProps: { textContent: _vm._s(link.label) }
                      })
                    ]
                  )
                }),
                _vm._v(" "),
                _vm.userId
                  ? _c(
                      "button",
                      {
                        staticClass: "button is-danger is-fullwidth mt-2",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.logout($event)
                          }
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("logout_link_label")))
                        ])
                      ]
                    )
                  : _vm._e()
              ],
              2
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "has-text-centered mb-4" }, [
      _c("img", {
        attrs: { src: "/static/img/login_img.png", alt: "Tooddoc Logo" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b97b26f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b97b26f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Doctor/Home.vue
// module id = 610
// module chunks = 1